import { render, staticRenderFns } from "./UserCell.vue?vue&type=template&id=f6ca049e&scoped=true"
import script from "./UserCell.vue?vue&type=script&lang=js"
export * from "./UserCell.vue?vue&type=script&lang=js"
import style0 from "./UserCell.vue?vue&type=style&index=0&id=f6ca049e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ca049e",
  null
  
)

export default component.exports